<template>
  <DsShowcase title="InputRadioPlay" description="Radio button customizado com v-model.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model</code> + <code>value</code> — todos compartilham o mesmo <code>name</code></p>
      <div class="tw:flex tw:flex-col tw:gap-3">
        <InputRadioPlay id="plan-free" v-model="plan" value="free" label="Plano Gratuito" name="plan" />
        <InputRadioPlay id="plan-pro" v-model="plan" value="pro" label="Plano Pro" name="plan" />
        <InputRadioPlay id="plan-enterprise" v-model="plan" value="enterprise" label="Plano Enterprise" name="plan" />
      </div>
      <p class="tw:text-xs tw:mt-3 tw:opacity-50">Selecionado: {{ plan }}</p>
    </section>

    <!-- Disabled -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:flex-col tw:gap-3">
        <InputRadioPlay id="dis-a" model-value="a" value="a" label="Selecionado + disabled" name="dis" :disabled="true" />
        <InputRadioPlay id="dis-b" model-value="a" value="b" label="Não selecionado + disabled" name="dis" :disabled="true" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { InputRadioPlay } from '@/components/atomic'

const plan = ref('pro')
</script>
